import {isErrorForClient} from './errors'

const enforcedSsoErrorKey = 'ssoRequiredError'

/**
 * Extracts the server's user-facing message from an enforced-SSO sign-in rejection — a 401 body
 * (or thrown parsed body) whose key is `ssoRequiredError` — and returns undefined for anything
 * else, including malformed bodies an edge proxy can produce.
 */
export const enforcedSsoRejectionMessage = (error: unknown): string | undefined => {
  if (!isErrorForClient(error) || error.key !== enforcedSsoErrorKey || error.message === '') {
    return undefined
  }
  return error.message
}

// One slot rather than a boolean beside a message, so a generic failure and an enforced-SSO
// rejection cannot both be presented at once. How each kind renders is the consuming form's choice.
export type OAuthSignInError = {kind: 'generic'} | {kind: 'ssoRejection'; message: string}

/** The next error-slot value after an OAuth sign-in attempt reports (show, error body). */
export const nextOAuthSignInError = (show: boolean, error: unknown): OAuthSignInError | undefined => {
  const rejection = enforcedSsoRejectionMessage(error)
  if (rejection !== undefined) {
    return {kind: 'ssoRejection', message: rejection}
  }
  return show ? {kind: 'generic'} : undefined
}
